var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:_vm.$style.home_menu},[_c('app-prev-button'),_c('app-home-menu',{class:_vm.$style.no_transition})],1)}
var staticRenderFns = []

export { render, staticRenderFns }